import React, { useEffect, useState } from "react";
import Footer from "../../layouts/Footer";
import Navbar from "../../layouts/Navbar";
import "../../styles/Favourites.css";
import api from "../../api/config";
import { ToastContainer, toast } from "react-toastify";
import NoDataFound from "../../components/common/NoDataFound";
import LoadingComponent from "../../components/common/Loading";
import FavoriteList from "../../components/user/FavoriteList";

const MyFavourite = () => {
  const [favouriteList, setFavouriteList] = useState([]);
  const [loading, setLoading] = useState(true);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const fetchFavouriteList = async () => {
      setLoading(true);
      try {
        const response = await api.get("/shortlisted-space-feed");
        //console.logresponse, "respo");
        if (response?.data?.status === 200) {
          setFavouriteList(response?.data?.response);
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchFavouriteList();
  }, []);
  return (
    <>
    <ToastContainer />
      <div>
        <Navbar />
        <div className="row py-5 align-items-center">
          <div className="col">
            <h4 className="mt-5 mx-3 ">My Favourites</h4>
          </div>
        </div>
        <div className="container">
          <div className="row ">
            {!loading && favouriteList?.length === 0 && <NoDataFound />}
            {loading ? (
              <>
                <LoadingComponent
                  style={{ minHeight: "50vh" }}
                  className="d-flex justify-content-center align-items-center"
                />
              </>
            ) : (
              favouriteList?.length > 0 && (
                <>
                  <FavoriteList
                    favouriteList={favouriteList}
                    setFavouriteList={setFavouriteList}
                  />
                </>
              )
            )}
          </div>
        </div>
      </div>
      <div style={{ marginBottom: "100px" }}></div> <Footer />
    </>
  );
};

export default MyFavourite;
